// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"mZ-z","sponsoredTooltipWrapper":"nZ-z","sponsoredTooltip":"oZ-z","newCard":"pZ-z"};